import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import type { FC } from 'react'

interface DatePickerProps {
  label: string
  value: string
  field: string
  onChange: (field: string, newValue: dayjs.Dayjs | null) => void
}

export const CustomDatePicker: FC<DatePickerProps> = ({
  label,
  value,
  onChange,
  field,
}) => {
  return (
    <DatePicker
      label={label}
      value={dayjs(value)}
      onChange={(newValue) => {
        onChange(field, newValue)
      }}
      slotProps={{
        textField: { size: 'small' },
      }}
      sx={{ width: '100%' }}
    />
  )
}
